import React from "react";
import {
  FormControl,
  Select,
  MenuItem,
  makeStyles,
  InputAdornment,
} from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  formControlRoot: {
    minWidth: "100px",
    "& .MuiInputBase-root": {
      borderRadius: "50px",
      height: "35px",
      "& .MuiSelect-select:focus": {
        backgroundColor: "transparent",
      },
      "& .MuiSelect-selectMenu": {
        minHeight: 0,
      },
    },
    "& .MuiInputLabel-root": {
      // transform: "translate(14px, 11px)",
    },
    "& .MuiSvgIcon-root": {
      color: "#3699FF",
    },
  },
}));

export default (props) => {
  const { label, prefixIcon, itemList, value, setValue } = props;
  const classes = useStyles();
  return (
    <FormControl variant="outlined" classes={{ root: classes.formControlRoot }}>
      <Select
        value={value}
        placeholder={label}
        displayEmpty
        onChange={(e) => {
          setValue(e.target.value);
        }}
        startAdornment={
          <InputAdornment position="start">{prefixIcon}</InputAdornment>
        }
      >
        <MenuItem value="">
          <em>{label}</em>
        </MenuItem>
        {itemList &&
          itemList.map((item) =>
            typeof item === "object" ? (
              <MenuItem key={item.key} value={item.value}>
                {item.key}
              </MenuItem>
            ) : (
              <MenuItem value={item}>{item}</MenuItem>
            )
          )}
      </Select>
    </FormControl>
  );
};
